import { copyToClipboard } from '../../export';
import type { Translator } from '../../i18n';

/**
 * Copies a share link and reports the outcome.
 *
 * Lives outside the dialog component so the module stays component-only and
 * React Fast Refresh keeps working on it.
 */
export async function copyShareLink(
  url: string,
  tooLong: boolean,
  t: Translator['t'],
  notify: (message: string, tone: 'success' | 'error') => void,
): Promise<void> {
  if (tooLong) {
    notify(t('export.linkTooLong'), 'error');
    return;
  }
  const copied = await copyToClipboard(url);
  notify(copied ? t('export.linkCopied') : t('export.failed'), copied ? 'success' : 'error');
}
